"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

// This map is needed for the product ownership adapters / ownsHigherTier stuff
// so they can account for the fact that these products represent the same tier
// even though they have to be ordered in ProductTierOrders
var _default = [[MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019, MerchandiseIds.PRODUCT_MARKETING_STARTER_MC], [MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_MC], [MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_MC]];
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/SynonymousProducts.js
// module id = 278
// module chunks = 5 6 7